import { ParsedUrlQueryInput } from 'querystring'

export enum BABY_POOP_PAGE_TYPE {
  INTRO = '',
  DETAIL = 'detail',
}

export type handleRedirectPage = (
  pageType: keyof typeof BABY_POOP_PAGE_TYPE,
  query?: string | ParsedUrlQueryInput | null,
  redirectType?: 'replace' | 'push',
) => void
